import $ from "jquery";
var Banner = /** @class */ (function () {
    function Banner(el) {
        var _this = this;
        this.currentPercentImage = 0;
        this.currentPercentContent = 0;
        this.$el = $(el);
        if (!this.$el.length)
            return;
        this.window = $(window);
        this.stickyContainer = $("main");
        this.imageScrollEffects = this.$el.find(".page-banners-image-scroll-effects-container");
        this.contentScrollEffects = this.$el.find(".page-banners-content-scroll-effects-container");
        this.registerVisibility();
        this.visibility();
        this.resize();
        $(window).on("scroll", function () {
            _this.scroll();
        });
        $(window).on("resize", function () {
            _this.resize();
        });
        this.slideDuration = 5000;
        this.initBanners();
    }
    Banner.prototype.registerVisibility = function () {
        var _this = this;
        if (typeof document.hidden !== "undefined") {
            this.visibilityFlag = "hidden";
            this.visibilityEvent = "visibilitychange";
        }
        else if (typeof document.msHidden !== "undefined") {
            this.visibilityFlag = "msHidden";
            this.visibilityEvent = "msvisibilitychange";
        }
        else if (typeof document.webkitHidden !== "undefined") {
            this.visibilityFlag = "webkitHidden";
            this.visibilityEvent = "webkitvisibilitychange";
        }
        $(document).on(this.visibilityEvent, function () {
            _this.visibility();
        });
    };
    Banner.prototype.visibility = function () {
        this.windowVisible = !document[this.visibilityFlag];
        if (this.windowVisible) {
            this.rafLastTimestamp = performance.now();
        }
    };
    Banner.prototype.scroll = function () {
        this.scrollTop = this.window.scrollTop();
        this.handleTriggers();
    };
    Banner.prototype.resize = function () {
        this.windowHeight = this.window.height();
        this.scrollTop = this.window.scrollTop();
        var headerHeight = $("header").outerHeight();
        var navHeight = $("#global-nav").outerHeight();
        var bannerHeight = this.$el.outerHeight();
        if (this.window.width() <= 700) {
            var top = 0;
            this.triggerImage = top;
            this.imageOver = Math.min(bannerHeight, this.windowHeight);
        }
        else {
            var top = navHeight;
            if (navHeight + bannerHeight > this.windowHeight) {
                top = this.windowHeight - bannerHeight;
            }
            this.triggerImage = navHeight - top;
            this.imageOver = Math.min(bannerHeight, this.windowHeight - navHeight);
        }
        this.$el.css("top", top);
        // this.triggerImage = navHeight - top;
        // this.imageOver = Math.min(bannerHeight, this.windowHeight - navHeight);
        this.triggerContent = this.triggerImage;
        this.contentOver = this.imageOver / 2;
        this.scroll();
        this.rafLastTimestamp = performance.now();
        this.raf();
    };
    Banner.prototype.handleTriggers = function () {
        // Image
        if (this.scrollTop >= this.triggerImage && this.scrollTop <= this.triggerImage + this.imageOver) {
            this.targetPercentImage = (this.scrollTop - this.triggerImage) / this.imageOver;
        }
        else {
            if (this.scrollTop < this.triggerImage) {
                this.targetPercentImage = 0;
            }
            else {
                this.targetPercentImage = 1;
            }
        }
        // Content
        if (this.scrollTop >= this.triggerContent && this.scrollTop <= this.triggerContent + this.contentOver) {
            this.targetPercentContent = (this.scrollTop - this.triggerContent) / this.contentOver;
        }
        else {
            if (this.scrollTop < this.triggerContent) {
                this.targetPercentContent = 0;
            }
            else {
                this.targetPercentContent = 1;
            }
        }
    };
    Banner.prototype.raf = function () {
        this.rafId = window.requestAnimationFrame(this.raf.bind(this));
        if (!this.windowVisible)
            return;
        this.rafCurrentTimestamp = performance.now();
        this.rafDelta = this.rafCurrentTimestamp - this.rafLastTimestamp;
        if (this.rafDelta == 0)
            return;
        this.rafLastTimestamp = this.rafCurrentTimestamp;
        var targetFrameRate = 1000 / 60;
        this.rafNormalizedTime = targetFrameRate / this.rafDelta;
        this.renderImageComponent();
        this.renderContentComponent();
    };
    Banner.prototype.renderImageComponent = function () {
        if (Math.abs(this.currentPercentImage - this.targetPercentImage) < 0.001) {
            if (this.targetPercentImage == 0 || this.targetPercentImage == 1) {
                this.currentPercentImage = Math.round(this.currentPercentImage);
            }
            else {
                return;
            }
        }
        var currentPercentImage = this.currentPercentImage;
        currentPercentImage += (this.targetPercentImage - currentPercentImage) / (15 * this.rafNormalizedTime);
        this.currentPercentImage = currentPercentImage;
        var scaleImage = this.remap(currentPercentImage, 0, 1, 1, (100 / 110));
        this.prefix(this.imageScrollEffects, "transform", "scale(" + scaleImage + ")");
    };
    Banner.prototype.renderContentComponent = function () {
        if (Math.abs(this.currentPercentContent - this.targetPercentContent) < 0.001) {
            if (this.targetPercentContent == 0 || this.targetPercentContent == 1) {
                this.currentPercentContent = Math.round(this.currentPercentContent);
            }
            else {
                return;
            }
        }
        var currentPercentContent = this.currentPercentContent;
        currentPercentContent += (this.targetPercentContent - currentPercentContent) / (15 * this.rafNormalizedTime);
        this.currentPercentContent = currentPercentContent;
        var moveContent = this.remap(currentPercentContent, 0, 1, 0, this.contentOver / 2);
        var scaleContent = this.remap(currentPercentContent, 0, 1, 1, (98 / 110));
        var fadeContent = this.remap(currentPercentContent, 0, 1, 1, 0);
        this.prefix(this.contentScrollEffects, "transform", "scale(" + scaleContent + ")");
        this.contentScrollEffects.css("opacity", fadeContent);
    };
    Banner.prototype.resetBanner = function () {
        this.$el.css("top", "");
        this.prefix(this.imageScrollEffects, "transform", "");
        this.prefix(this.contentScrollEffects, "transform", "");
        this.contentScrollEffects.css("opacity", "");
    };
    Banner.prototype.remap = function (v, aMin, aMax, bMin, bMax) {
        return ((v - aMin) / (aMax - aMin)) * (bMax - bMin) + bMin;
    };
    Banner.prototype.prefix = function (el, prop, val) {
        el.css("-webkit-" + prop, val);
        el.css("-moz-" + prop, val);
        el.css("-ms-" + prop, val);
        el.css("-o-" + prop, val);
        el.css(prop, val);
    };
    Banner.prototype.initBanners = function () {
        this.pageBannerPillsInterface = this.$el.find(".page-banner-interface");
        this.pageBannerPills = this.$el.find(".page-banner-pill");
        this.bannerElements = this.$el.find(".page-banner-element");
        this.bannerCount = this.$el.attr("data-banner-count");
        this.banners_switchToBanner();
        if (this.bannerCount > 1) {
            this.bannerActive = 0;
            this.banners_initInterface();
            this.banners_cycleBanners();
        }
    };
    Banner.prototype.banners_initInterface = function () {
        var _this = this;
        this.pageBannerPills.each(function (key, el) {
            var pill = $(el);
            pill.on("click", function (e) {
                var target = $(e.target);
                var pos = target.attr("data-pos");
                _this.bannerActive = pos;
                _this.banners_switchToBanner(pos);
                _this.banners_cycleBanners();
            });
        });
    };
    Banner.prototype.banners_switchToBanner = function (pos) {
        if (pos === void 0) { pos = 0; }
        this.bannerElements.removeClass("active");
        this.bannerElements.filter("[data-pos=" + pos + "]").addClass("active");
        this.pageBannerPills.removeClass("active");
        this.pageBannerPills.filter("[data-pos=" + pos + "]").addClass("active");
        this.pageBannerPillsInterface.attr("data-theme", this.banners_getTheme(pos));
    };
    Banner.prototype.banners_cycleBanners = function () {
        var _this = this;
        clearTimeout(this.bannerTimeout);
        this.bannerTimeout = setTimeout(function () {
            _this.bannerActive++;
            if (_this.bannerActive == _this.bannerCount) {
                _this.bannerActive = 0;
            }
            _this.banners_switchToBanner(_this.bannerActive);
            _this.banners_cycleBanners();
        }, this.slideDuration);
    };
    Banner.prototype.banners_getTheme = function (pos) {
        return this.bannerElements.filter("[data-pos=" + pos + "]").attr("data-theme");
    };
    return Banner;
}());
export { Banner };
